import { useQuery, UseQueryResult } from "@tanstack/react-query"

import { useAuthedAxios } from "hooks/core/useAuthedAxios"
import { queryKeys } from "api/queryKeys"
import { fetchUnitUsers } from "api/Repos/users"

/**
 * React-query queries for the Units domain.
 */

/**
 * Fetches the usernames in the current user's unit (newline-separated on the
 * wire). The list changes rarely — cache it for 5 minutes.
 */
export const useUnitUsersQuery = (
  enabled: boolean = true
): UseQueryResult<string[]> => {
  const getAxios = useAuthedAxios()

  return useQuery({
    queryKey: queryKeys.units.users,
    enabled,
    staleTime: 5 * 60_000,
    meta: { errorTitle: "Error Fetching Data!" },
    queryFn: async (): Promise<string[]> => {
      const res = await fetchUnitUsers(await getAxios())
      return res.data.split("\n").filter((user) => user.trim() !== "")
    },
  })
}
